import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Link2Off } from "lucide-react";
import { API, errMsg } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { Card, ListSkeleton } from "@/components/common";
import { BrandSymbol } from "@/components/Brand";
import { TenantView } from "@/components/TenantView";

export default function PublicTenant() {
  const { token } = useParams();
  const { t } = useT();
  const [d, setD] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    axios.get(`${API}/public/t/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
  }, [token]);
  return (
    <div className="min-h-screen bg-[#F6F7F5]">
      <div className="max-w-md mx-auto px-4 pt-5 pb-12">
        <div className="flex items-center gap-2 min-w-0 mb-5">
          <BrandSymbol size={30} />
          <span data-testid="public-pg-name" className="font-bold truncate">{d?.property?.name || "Nexstays"}</span>
        </div>
        {err ? (
          <Card className="p-6 text-center" data-testid="public-invalid">
            <Link2Off className="h-10 w-10 mx-auto text-slate-400" />
            <p className="mt-3 text-slate-700">{t("pub_invalid")}</p>
          </Card>
        ) : !d ? <ListSkeleton rows={4} /> : (
          <>
            <TenantView d={d} onReceipt={(p) => window.open(`${API}/public/t/${token}/receipts/${p.id}.pdf`, "_blank")} />
            <p className="text-xs text-slate-400 text-center mt-3">{t("pub_footer")}</p>
          </>
        )}
      </div>
    </div>
  );
}
